<form  [formGroup]="componentForm" class="popupForm" style="min-height: 400px;">
  <div class="common" mat-dialog fxLayout="column" fxLayoutAlign="space-between" style="min-height: 400px;">
    <div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between end">
      {{'trainer_details'|GetLabelPipe}}
      <button mat-icon-button mat-dialog-close id="close-upload" alt="close" title="close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-dialog-content class="when-fx-layout-broke"
                        style="min-height: 420px; max-height: 80vh;">
      <div class="event-view-content event-view-content-first-row" style="justify-content: flex-start;">
        <div class="flex-column-center" style="width: 100%;">
          <div class="flex-row-center flex-justify-space-around" style="width: 100%;">
            <div class="event-user-icon event-user-icon-first-row" style="margin-top: 12px;">
              <img src="{{profile.picture_src_preview}}"
                   alt="{{profile.shipping_name}}" title="{{profile.shipping_name}}"
                   style="{{ profile.sex==='F' ? 'border-color: #FF1744' : 'border-color: #448AFF' }}"
              />
            </div>
          </div>
          <div class="user-name">
            {{profile.shipping_name}}
          </div>
        </div>
        <ng-container *ngIf="state === 'default'">
          <ng-container *ngIf="trainerDescription">
            <br>
            <div [innerHTML]="trainerDescription" class="infoText"></div>
          </ng-container>
          <br>
          <fieldset class="services-fieldset">
            <legend>{{'trainer_services'|GetLabelPipe}}</legend>
            <mat-radio-group matInput formControlName="pickedTrainerService"
                             *ngIf="profileServices && profileServices.length"
                             aria-labelledby="example-radio-group-label"
                             class="radio-group">
              <mat-radio-button *ngFor="let service of profileServices" [value]="service.service_key"
                                (click)="servicePick(service.service_key)"
                                class="radio-button">
                <div class="textCut">
                  {{service.service_name}} - <b>{{service.price}} {{service.currency|GetLabelPipe}}</b>
                </div>
              </mat-radio-button>
            </mat-radio-group>
            <div *ngIf="!profileServices || !profileServices.length">
              <br><br>{{'trainer_services_missing'|GetLabelPipe}}<br><br>
            </div>
          </fieldset>
          <br>
        </ng-container>
        <ng-container>
          <br>
          <div class="internal-spinner" *ngIf="state === 'loading'">
            <svg class="spinner" viewBox="25 25 50 50">
              <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
            </svg>
          </div>
        </ng-container>
        <div *ngIf="state === 'error'">
          >.< error.
        </div>
      </div>

    </mat-dialog-content>
    <div fxLayout="row" fxLayoutAlign="center end" fxLayoutGap="10px">
      <button class="widerButton font16" mat-raised-button color="accent" type="button"
              [disabled]="!servicePicked"
              (click)="orderClick()">
        {{'order_training'|GetLabelPipe}}
      </button>
    </div>
    <br>
  </div>
</form>
